import { Typography } from '@mui/material';

import StatusIconRenderer from '../../StatusIconRenderer';
import { ServiceCodes } from '../../billings/claims/constants';
import { FORTA_GRAY4 } from '../../../../utils/colors';

import type { SupervisionNoteStatus } from '../../../../constants';

export const clientAndBtSNHistoryColumns = [
  {
    name: 'id',
    options: {
      filter: false,
      sort: false,
      display: false,
    },
  },
  {
    name: 'status',
    label: 'Status',
    options: {
      filter: false,
      sort: false,
      customBodyRender: (value: SupervisionNoteStatus) => {
        return (
          <StatusIconRenderer procedureCode={ServiceCodes.ClientSNProcedureCode} status={value} />
        );
      },
    },
  },
  {
    name: 'client',
    label: 'Client',
    options: {
      filter: false,
      sort: true,
    },
  },
  {
    name: 'session_id',
    label: 'ID',
    options: {
      filter: false,
      sort: true,
    },
  },
  {
    name: 'date',
    label: 'Date',
    options: {
      filter: false,
      sort: true,
    },
  },
  {
    name: 'time',
    label: 'Time',
    options: {
      filter: false,
      sort: false,
    },
  },
  {
    name: 'duration',
    label: 'Duration',
    options: {
      filter: false,
      sort: false,
    },
  },
  {
    name: 'bt',
    label: 'BT',
    options: {
      filter: false,
      sort: true,
    },
  },
];

export const parentSNHistoryColumns = [
  {
    name: 'id',
    options: {
      filter: false,
      sort: false,
      display: false,
    },
  },
  {
    name: 'status',
    label: 'Status',
    options: {
      filter: false,
      sort: false,
      customBodyRender: (value: SupervisionNoteStatus) => {
        return (
          <StatusIconRenderer procedureCode={ServiceCodes.ParentSNProcedureCode} status={value} />
        );
      },
    },
  },
  {
    name: 'client',
    label: 'Client',
    options: {
      filter: false,
      sort: true,
    },
  },
  {
    name: 'session_id',
    label: 'ID',
    options: {
      filter: false,
      sort: true,
    },
  },
  {
    name: 'date',
    label: 'Date',
    options: {
      filter: false,
      sort: true,
    },
  },
  {
    name: 'time',
    label: 'Time',
    options: {
      filter: false,
      sort: false,
    },
  },
  {
    name: 'duration',
    label: 'Duration',
    options: {
      filter: false,
      sort: false,
    },
  },
];

export const groupSNHistoryColumns = [
  {
    name: 'id',
    options: {
      filter: false,
      sort: false,
      display: false,
    },
  },
  {
    name: 'status',
    label: 'Status',
    options: {
      filter: false,
      sort: false,
      customBodyRender: (value: SupervisionNoteStatus) => {
        return (
          <StatusIconRenderer procedureCode={ServiceCodes.GroupSNProcedureCode} status={value} />
        );
      },
    },
  },
  {
    name: 'client',
    label: 'Clients',
    options: {
      filter: false,
      sort: true,
      setCellProps: () => ({ style: { minWidth: '200px', maxWidth: '350px' } }),
      customBodyRender: (value: string) => {
        return <Typography color={FORTA_GRAY4}>{value}</Typography>;
      },
    },
  },
  {
    name: 'session_id',
    label: 'ID',
    options: {
      filter: false,
      sort: true,
    },
  },
  {
    name: 'date',
    label: 'Date',
    options: {
      filter: false,
      sort: true,
    },
  },
  {
    name: 'time',
    label: 'Time',
    options: {
      filter: false,
      sort: false,
    },
  },
  {
    name: 'duration',
    label: 'Duration',
    options: {
      filter: false,
      sort: false,
    },
  },
];
